import { TagGroup } from './types'

export function isValidGroup(group: string): group is TagGroup {
  return !!(
    group &&
    (group === 'archived' || group === 'unused' || group === 'used')
  )
}
